import { Core } from "@faire/design-tokens";
import { Button, ButtonProps } from "@faire/web--source/slate/Button";
import { Flex } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { StringContextType } from "@faire/web-api--source/faire/translator/StringContextType";
import React from "react";
import styled from "styled-components";

interface ISkipButtonConditionallyProps {
  onClick: () => void;
}

export const SkipButtonConditionally: React.FC<
  ISkipButtonConditionallyProps
> = ({ onClick }) => {
  return (
    <SkipButtonWrapper>
      <Spacer width="2x" />
      <SkipButton onClick={onClick} />
    </SkipButtonWrapper>
  );
};

const SkipButton: React.FC<ButtonProps> = (props) => {
  return (
    <StyledButton
      small
      variant="secondary"
      data-test-id="skip-order-page-btn"
      {...props}
    >
      <StrictLocalMsg
        defaultMessage="No, skip this step"
        description={{
          text: "This is a button that allows the user to skip the current step in the self-serve flow.",
          stringDescriptors: [StringContextType.CALL_TO_ACTION],
        }}
      />
    </StyledButton>
  );
};

const StyledButton = styled(Button)`
  &:hover {
    color: ${Core.text.hover};
    background-color: ${Core.text.inverse};
  }

  padding: ${getSpacing("3x")}};
  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
const SkipButtonWrapper = styled(Flex).attrs({
  direction: { tabletAndAbove: "row", mobileAndAbove: "column" },
})`
  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
